import React, { memo, useState, useEffect } from "react";
import { Stack } from "investira.react.components";
import { BaseTemplate } from "../../components/templates";
import { useSelector } from "react-redux";
import { SearchAtivosAdd } from "../../components/organisms";
import AtivosBlacklist from "./AtivosBlacklist";
import services from "../../services";
import withResponseHandling from "../../hoc/withResponseHandling";

const BlacklistFundos = memo(() => {
  const { default_entidade_id } = useSelector(
    (store) => store.entidade.current
  );

  const [posicoes, setPosicoes] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  function handleClick(pIfeedAtivoId) {
    services.posicoes.fechadasAdd(
      {
        entidade_id: default_entidade_id,
        ifeed_ativo_id: pIfeedAtivoId,
      },
      () => {
        services.posicoes.fechadasList({ sort: "ativo_id" }, (rRes) => {
          setPosicoes(rRes.data);
        });
      },
      (rErr) => {}
    );
  }

  function handleDelete(pIfeedAtivoId) {
    services.posicoes.fechadasRemove(
      {
        entidade_id: default_entidade_id,
        ativo_id: pIfeedAtivoId,
      },
      () => {
        services.posicoes.fechadasList({ sort: "ativo_id" }, (rRes) => {
          setPosicoes(rRes.data);
        });
      },
      (rErr) => {}
    );
  }

  useEffect(() => {
    setIsLoading(true);
    services.posicoes.fechadasList(
      { sort: "ativo_id" },
      (rRes) => {
        setPosicoes(rRes.data);
      },
      (rErr) => {},
      () => {
        setIsLoading(false);
      }
    );
  }, [default_entidade_id]);

  return (
    <BaseTemplate title="Fundos Excepcionalmente Não Abertos" maxWidth="lg">
      <Stack spacing={4}>
        <SearchAtivosAdd onClick={handleClick} pageIsLoading={isLoading} />
        <AtivosBlacklist
          posicoes={posicoes}
          onDelete={handleDelete}
          isLoading={isLoading}
        />
      </Stack>
    </BaseTemplate>
  );
});

export default withResponseHandling(BlacklistFundos);
